import React, { PureComponent, Fragment } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import env from "../../constants/env";

class ShareModelModal extends PureComponent {
  state = {
    copied: false
  };

  constructor(props) {
    super(props);
    this.onCopy = this.onCopy.bind(this);
  }

  onCopy() {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 3000);
  }

  render() {
    const url = `${env.REACT_APP_PUBLIC_URL}/create?from=${this.props.id}`;

    return (
      <Fragment>
        <div className="modal__header">
          <span>{this.props.t("modals:shareModelTitle")}</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>

          <div className="pa5 tc">
            <div className="mb2">{this.props.t("modals:shareModelText")}</div>
            <div className="form-stack">
              <input
                readOnly
                type="text"
                className="form-stack__input"
                value={url}
              />
              <CopyToClipboard
                text={url}
                onCopy={this.onCopy}
                className="form-stack__button"
              >

                <span>{this.state.copied ? this.props.t("modals:shareModelCopiedText") : this.props.t("modals:shareModelCopyText")}</span>
              </CopyToClipboard>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ShareModelModal;



// WEBPACK FOOTER //
// ./src/components/modals/ShareModelModal.js